import { $authHost } from ".."
import { getStartParamsQuery } from "../../helpers/api/apiHelper"

export const editSupplyBillItemPriceAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/change_price/${dataForBd.id}`, dataForBd)
    return data
}

export const editSupplyBillItemSkuAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/change_sku/${dataForBd.id}`, dataForBd)
    return data
}

export const editSupplyBillItemExpenseTypeAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/change_expense_type/${dataForBd.id}`, dataForBd)
    return data
}

export const editSupplyBillItemNameInBillAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/change_name_in_bill/${dataForBd.id}`, dataForBd)
    return data
}

export const editSupplyBillItemContractAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/change_contract/${dataForBd.id}`, dataForBd)
    return data
}

export const agreeSupplyBillItemNachAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/agree_nach/${dataForBd.id}`, dataForBd)
    return data
}
export const agreeSupplyBillItemAllNachAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/agree_nach_all/${dataForBd.supplyBillId}`, dataForBd)
    return data
}

export const agreeSupplyBillItemDeputyDirectorSupplyAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/agree_deputy_director_supply/${dataForBd.id}`, dataForBd)
    return data
}
export const agreeSupplyBillItemAllDeputyDirectorSupplyAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/agree_deputy_director_supply_all/${dataForBd.supplyBillId}`, dataForBd)
    return data
}

export const agreeSupplyBillItemEconomistAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/agree_economist/${dataForBd.id}`, dataForBd)
    return data
}
export const agreeSupplyBillItemAllEconomistAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/agree_economist_all/${dataForBd.supplyBillId}`, dataForBd)
    return data
}

export const agreeSupplyBillItemHeaderAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/agree_header/${dataForBd.id}`, dataForBd)
    return data
}
export const agreeSupplyBillItemAllHeaderAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_bill_items/agree_header_all/${dataForBd.supplyBillId}`, dataForBd)
    return data
}

export const deleteSupplyBillItemAPI = async ({ supplyBillItemId }) => {
    const {data} = await $authHost.delete(`api/supply_bill_items/${supplyBillItemId}`)
    return data
}

export const getSupplyBillAllItems = async ({ 
    offset, limit, query, status, agreeNachSupply, agreeEconomist, agreeDeputyDirectorSupply, agreeHeader 
}) => {

    let params = ''
    if (query) {
        params = `${getStartParamsQuery({ params })}query=${query}`
    }
    
    if ((offset || offset === 0) && limit) {
        params += `${getStartParamsQuery({ params })}offset=${offset}&limit=${limit}`
    }

    if (status) {
        params += `${getStartParamsQuery({ params })}status=${status}`
    }
    if (agreeNachSupply) {
        params += `${getStartParamsQuery({ params })}agreeNachSupply=${agreeNachSupply}`
    }
    if (agreeEconomist) {
        params += `${getStartParamsQuery({ params })}agreeEconomist=${agreeEconomist}`
    }
    if (agreeDeputyDirectorSupply) {
        params += `${getStartParamsQuery({ params })}agreeDeputyDirectorSupply=${agreeDeputyDirectorSupply}`
    }
    if (agreeHeader) {
        params += `${getStartParamsQuery({ params })}agreeHeader=${agreeHeader}`
    }

    const {data} = await $authHost.get(`api/supply_bill_items/all${params}`)
    return data
}